import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';
//import { Phone } from "@mui/icons-material";

const defaultToolbarStyles = {
    iconButton: {
    },
};


class OperatorAdd extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            operator: [],
            OperatorId: null,
            Name: null,
            Description: null,
            Email: null,
            Phone: null,
            Modifier: null,
            StartTime: null,
            EndTime: null
        };
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            openAddressSearch: false,
            operator: [],
            OperatorId: null,
            Name: null,
            Description: null,
            Email: null,
            Phone: null,
            Modifier: null,
            StartTime: null,
            EndTime: null
        });
    }

    handleSave = () => {
        this.props.onAddNewRow({
            OperatorId: 1,
            Name: this.state.Name,
            Description: this.state.Description,
            Email: this.state.Email,
            Phone: this.state.Phone,
            Modifier: this.state.Modifier,
            StartTime: this.state.StartTime,
            EndTime: this.state.EndTime
        });

        this.handleClearData();
    };

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true });
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.NewRow}>
                    <IconButton onClick={this.handleClickOpen}>
                        <AddIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.Operator.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Operator.Columns[1]}
                            type="text"
                            fullWidth
                            value={this.state.Name}
                            onChange={this.handleChange('Name')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Operator.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.Description}
                            onChange={this.handleChange('Description')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Operator.Columns[3]}
                            type="text"
                            fullWidth
                            value={this.state.Email}
                            onChange={this.handleChange('Email')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Operator.Columns[4]}
                            type="text"
                            fullWidth
                            value={this.state.Phone}
                            onChange={this.handleChange('Phone')}
                        />
                        
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "OperatorAdd" })(OperatorAdd);
